var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrap"}},[_c('guide',{attrs:{"date":_vm.GuidePage},on:{"guideClick":_vm.guideClick}}),_c('plate',{attrs:{"date":_vm.formDate}}),_c('banner',{attrs:{"date":_vm.RotationChart}}),_c('base-bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }